/**
 * EmptyState component shown when there are no flashcards.
 *
 * @returns {React.ReactElement} Empty state message
 */
export default function EmptyState() {
  return (
    <div className="empty-state">
      <div className="empty-state__icon" aria-hidden="true">
        📝
      </div>
      <h3 className="empty-state__title">Brak fiszek</h3>
      <p className="empty-state__text">
        Zacznij od zaimportowania pierwszych fiszek powyżej.
      </p>
    </div>
  )
}
